export default __webpack_public_path__ + "static/media/advertisement.6d7ed577.png";